<template>
  <v-speed-dial v-model="active" :direction="direction" :open-on-hover="false" style="float: right; z-index: 1">
    <template v-slot:activator>
      <v-btn v-model="active" color="green" dark small>
        <v-icon>{{ active ? 'close' : 'menu_open' }}</v-icon>
      </v-btn>
    </template>
    <FormSettings></FormSettings>
    <Upload/>
    <v-btn :color="byUser ? 'orange' : ''" @click="$emit('byUser')">
      <v-icon block fab small>person</v-icon>
    </v-btn>
    <v-btn v-if="kanbanEnabled()" @click="goToKanban()">
      <v-icon block color="red darken-3" fab small style="color: #efefef">view_kanban</v-icon>
    </v-btn>
    <v-btn @click="$emit('print')">
      <v-icon :disabled="!docAvailable" block color="blue-grey darken-2" fab small style="color: #efefef">print</v-icon>
    </v-btn>
    <v-btn @click="$emit('confirmAll')">
      <v-icon block color="orange darken-4" fab small style="color: #efefef">check</v-icon>
    </v-btn>
    <v-btn @click="$emit('printAllCsv')">
      <v-icon block color="green darken-3" fab small style="color: #efefef">receipt</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>

import Upload from "@/components/form/Upload.vue"
import FormSettings from "@/components/form/FormSettings.vue"

const MIN_SCREEN_WIDTH = 800
export default {
  components: {FormSettings, Upload},
  props: ['docAvailable', 'byUser'],
  data() {
    return {
      active: false
    }
  },
  computed: {
    direction() {
      return window.screen.width < MIN_SCREEN_WIDTH ? 'bottom' : 'left'
    }
  },
  methods: {
    goToKanban() {
      this.$router.push('/form/' + this.$route.params.schemaId + '/kanban')
    },
    kanbanEnabled() {
      let schema = this.$store.state.forms.schema
      return !!schema && !!schema.kanban && schema.kanban.length > 0
    }
  }
}
</script>


<style scoped>

</style>